const config = {
    baseUrl: '/',
     //apiUrl: "http://localhost:8000/api",
     //imageUrl: 'http://localhost:8000/api/uploads/',
	 //bannersUrl: 'http://localhost:8000/api/banners/',
     //domainImg:'http://localhost:8000/api/domains/',
     //mail_images:'http://localhost:8000/api/mail_images/',
    // apiUrl: "https://bondi.lyonsdemo.in/apis/api/",
    // imageUrl: 'https://bondi.lyonsdemo.in/apis/api/uploads/',
    // bannersUrl: 'https://bondi.lyonsdemo.in/apis/api/banners/',
    // domainImg: 'https://bondi.lyonsdemo.in/apis/api/domains/',
    // mail_images:'https://bondi.lyonsdemo.in/apis/api/mail_images/',
    apiUrl: "https://apis.bondiclassifieds.com.au/api",
    adImgUrl: 'https://apis.bondiclassifieds.com.au/api/items/',
    imageUrl: 'https://apis.bondiclassifieds.com.au/api/uploads/',
    bannersUrl: 'https://apis.bondiclassifieds.com.au/api/banners/',
    domainImg: 'https://apis.bondiclassifieds.com.au/api/domains/',
    mail_images:'https://apis.bondiclassifieds.com.au/api/mail_images/',
    
    site_key: "6LdlcxEsAAAAALaIFi9XBgfU_rJVgkKNI6-Hu-tQ",  
    secret_key: "6LdlcxEsAAAAAFbgV9PDX5HMC_76zH4KmpbzKYvY",
    superAdmin: 1,
    cat_per: 1,
    cat_real: 3,
    cat_buy: 4,
    cat_whats: 5,
    cat_jobs: 6,
    cat_eat: 7,
    cat_business: 76,
    paging_size: 25,
    stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_51RZNiFHM6mINEQKLeNkrbV4OYIlhhbiKqELNxRm4SUDKG7HYHoH249LZE0UyqxlanaHeMoF5vcrUZ9EhcgQJ2ZQW00BlFLbx5Q'
}
export default config;
